/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown>, date: NonNullable<unknown> }} Search_Action_Weight_MetaInputs */

const en_us2_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last: ${i?.valueText} on ${i?.date}`)
};

const pt_br2_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último: ${i?.valueText} em ${i?.date}`)
};

const es_419_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último: ${i?.valueText} el ${i?.date}`)
};

const pt_pt2_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último: ${i?.valueText} em ${i?.date}`)
};

const fr_fr2_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernier : ${i?.valueText} le ${i?.date}`)
};

const de_de2_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt: ${i?.valueText} am ${i?.date}`)
};

const it_it2_search_action_weight_meta = /** @type {(inputs: Search_Action_Weight_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultimo: ${i?.valueText} il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last: {valueText} on {date}" |
*
* @param {Search_Action_Weight_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_weight_meta = /** @type {((inputs: Search_Action_Weight_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Weight_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_weight_meta(inputs)
	if (locale === "es-419") return es_419_search_action_weight_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_weight_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_weight_meta(inputs)
	if (locale === "de-DE") return de_de2_search_action_weight_meta(inputs)
	if (locale === "it-IT") return it_it2_search_action_weight_meta(inputs)
	return en_us2_search_action_weight_meta(inputs)
});
export { search_action_weight_meta as "search.action_weight_meta" }